import { CenteredLayout, Css } from "@homebound/beam";
import {
  PlanPackageOverviewV2Query,
  usePlanPackageOverviewV2Query,
} from "src/routes/libraries/plan-package-v2/components/OverviewTab.generated";
import { ElevationsCard } from "src/routes/libraries/plan-package-v2/components/overview/ElevationsCard";
import { PlanSummary } from "src/routes/libraries/plan-package-v2/components/overview/PlanSummary";
import { RecentActivityCard } from "src/routes/libraries/plan-package-v2/components/overview/RecentActivityCard";
import { queryResult } from "src/utils";

type OverviewTabProps = { planPackageId: string; versionId: string };

export function OverviewTab({ planPackageId, versionId }: OverviewTabProps) {
  const query = usePlanPackageOverviewV2Query({ variables: { id: planPackageId, versionId } });
  return queryResult(query, ({ planPackage }) => <DataView planPackage={planPackage} />);
}

type DataViewProps = { planPackage: PlanPackageOverviewV2Query["planPackage"] };

function DataView({ planPackage }: DataViewProps) {
  const { id, options } = planPackage;
  const activeOptions = options.filter((o) => o.active);
  const elevations = activeOptions.filter((o) => o.type.isElevation).sortBy((o) => o.order);
  const exteriorSchemeCount = activeOptions.filter((o) => o.type.isExteriorScheme).length;

  return (
    <CenteredLayout size="lg">
      <div css={Css.py3.df.fdc.gap4.ifSm.py2.gap3.$}>
        <PlanSummary planPackage={planPackage} elevations={elevations} />
        <div css={Css.df.aifs.gap4.ifSm.fdc.aiStretch.gap3.$}>
          <div css={Css.wPx(330).fs0.ifSm.w100.$}>
            <ElevationsCard elevations={elevations} exteriorSchemeCount={exteriorSchemeCount} />
          </div>
          <div css={Css.fg1.$}>
            <RecentActivityCard
              planPackageId={id}
              optionIds={options.map((o) => o.id)}
              programDataModificationIds={options.flatMap((o) => o.programDataModifiedBy.map((pdm) => pdm.id))}
            />
          </div>
        </div>
      </div>
    </CenteredLayout>
  );
}
